module.exports = __webpack_public_path__ + "static/media/wzwn.16708008.png";